import { Button } from 'antd'
import { IScanBlockchain } from 'api'
import FormikInput from 'components/FormikInput'
import { useFormikContext } from 'formik'
import { Form, FormItem } from 'formik-antd'
import { useLocalization } from 'localization'

export interface IFormValues extends Pick<IScanBlockchain, 'walletAddress'> {}

const ScanBlockchainForm = () => {
	const { t } = useLocalization()
	const { isSubmitting, isValid, dirty } = useFormikContext<IFormValues>()

	return (
		<Form layout="vertical">
			<FormItem name="walletAddress" label={t('terms.walletAddress')} required>
				<FormikInput name="walletAddress" placeholder={t('placeholders.walletAddress')} />
			</FormItem>
			<Button type="primary" htmlType="submit" loading={isSubmitting} disabled={!isValid || !dirty}>
				{t('actions.submit')}
			</Button>
		</Form>
	)
}

export default ScanBlockchainForm
